// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { aiSkillsManifest } from './ai-skills';
import { factBaseRagManifest } from './fact-base-rag';

/** Група модулів «Керування ШІ» (AiManagement): 2 модулів. */
export const aiManagementGroup: IModuleGroupManifest = {
  key: 'ai-management',
  category: 'AI management',
  name: { en: 'AI management', uk: 'Керування ШІ' },
  sort: 6,
  modules: [aiSkillsManifest, factBaseRagManifest],
};
